module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUoAAADcAgMAAABrDwB8AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAADFBMVEUAK3/80RbOESb////a6BnuAAAAAWJLR0QDEQxM8gAAAAd0SU1FB+kMAwk1DmCCdjsAAABiSURBVHja7cwxAQAgDAOwPpOIP25UoqDfzkRAkm5O97obp9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op2r5wfNH6vymy6jgwAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyNS0xMi0wM1QwOTo1MzoxNCswMDowMFoeIVMAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjUtMTItMDNUMDk6NTM6MTQrMDA6MDArQ5nvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/lmny.png
// module id = Ojv9
// module chunks = 128